import { cn } from '@/lib/utils'

interface SpinnerProps {
  size?: number | 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}

const sizeMap = {
  sm: 12,
  md: 16,
  lg: 20,
  xl: 24,
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
  const pixelSize = typeof size === 'number' ? size : sizeMap[size]
  
  return (
    <div
      className={cn(
        'rounded-full animate-spin border-2 border-current border-t-transparent opacity-70',
        className
      )}
      style={{
        width: pixelSize,
        height: pixelSize,
      }}
    />
  )
}
